export default (data) => !data.Input;
